import { useEffect, useState } from 'react';

import { get } from '@/libs/axios';
import useGlobalConfig from '@/store/global';

import FormContent from './form-content';

const PatientAssistanceRequests = () => {
  const [loading, setLoading] = useState(true);
  const { program } = useGlobalConfig();
  const name = program.name;
  const [assistances, setAssistances] = useState({});
  const programArray = ['gammaked', 'prolastin', 'xembify'];

  useEffect(() => {
    loadAssistanceRequest();
  }, []);

  const loadAssistanceRequest = async () => {
    try {
      const { data } = await get('patient_assistance_requests/current');
      setAssistances(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {programArray.includes(name) && (
        <FormContent
          isReceived={!!Object.keys(assistances).length}
          loading={loading}
          programName={name}
        />
      )}
    </>
  );
};

export default PatientAssistanceRequests;
